/**
 * uiBreadcrumbs automatic breadcrumbs directive for AngularJS & Angular ui-router.
 *
 * https://github.com/michaelbromley/angularUtils/tree/master/src/directives/uiBreadcrumbs
 *
 * Copyright 2014 Michael Bromley <michael@michaelbromley.co.uk>
 */
import globalConfig from '../globals/globalConfig.json';

(function () {
    /**
     * Config
     */
  var moduleName = 'ngBreadCrumb'
  var templateUrl = 'ngBreadCrumbTemplate.html'

    /**
     * Module
     */
  var module
    // try {
    //     module = angular.module(moduleName);
    // } catch (err) {
    //     // named module does not exist, so create one
    //     module = angular.module(moduleName, ['ui.router']);
    // }
  angular.module(moduleName, [])
  .directive('uiBreadcrumbs',['$interpolate','$state', '$stateParams','$rootScope','$cookies', 'GlobalSrv', '$interval','GlobalConfig',uiBreadcrumbs ]);

    function uiBreadcrumbs($interpolate, $state, $stateParams, $rootScope, $cookies, GlobalSrv, $interval, GlobalConfig) {   
      return {
        restrict: 'E',
        templateUrl: function (elem, attrs) {
          return attrs.templateUrl || templateUrl
        },
        scope: {
          displaynameProperty: '@',
          abstractProxyProperty: '@?'
        },
        link: function (scope) {
          scope.breadcrumbs = []
          var roleId = false
          //let roleId = $cookies.get('hasRoleId')

          let getCurrentUser = $interval(function () {
            let cookieUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false
              if (cookieUser) {
                roleId = $cookies.get('hasRoleId') ? JSON.parse($cookies.get('hasRoleId')) : false
                if(roleId)
                  {
                    loadContent()
                    $interval.cancel(getCurrentUser)
                  }
               }
           }, 500)

          function loadContent()
          {
            if ($state.$current.name !== '') {
              updateBreadcrumbsArray()
              if (scope.breadcrumbs[1] && !scope.breadcrumbs[1].order) {
                  scope.breadcrumbs.shift()
              }
            }

            scope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
              updateBreadcrumbsArray()
              if (scope.breadcrumbs[1] && !scope.breadcrumbs[1].order) {
                scope.breadcrumbs.shift()
              }
              $rootScope.previousState = to
            })
          }



          function filterOptions (breadcrumbs, callback) {
            let currentUser = JSON.parse($cookies.get('currentUser'))
            let breadcrumbsNew = []
            let params = {
              ID_ROLE: roleId,
              ID_TEACHER: $stateParams.teacherId,
              ID_USER: currentUser.id,
              WORKPLAN_ID: $stateParams.workplanId
            }
            GlobalSrv.roles.getAccessModules(params).$promise.then((response) => {
              console.log("response--------->",response)
              //console.log("breadcrumbs--/->",breadcrumbs)
              if (!response.status) {
                console.log('Ocurrio un error en el servicio')
              } else {
                for (let i in breadcrumbs) {
                  for (let x in response.data) {
                    if (breadcrumbs[i].displayName.toLowerCase() == response.data[x].ds_name.toLowerCase()
                      || breadcrumbs[i].displayName.toLowerCase() == 'resumen' || breadcrumbs[i].displayName.toLowerCase() == 'inicio') //|| breadcrumbs[i].displayName.toLowerCase() == 'inicio'
                       {
                      breadcrumbsNew.push(breadcrumbs[i])
                      break
                    }
                  }
                }
               // console.log("breadcrumbsNew--->",breadcrumbsNew)
                callback(breadcrumbsNew)
              }
            }, (err) => {
              console.log('Imposible conectar con el servicio')
            })
          }
                /**
                 * Start with the current state and traverse up the path to build the
                 * array of breadcrumbs that can be used in an ng-repeat in the template.
                 */
          function updateBreadcrumbsArray () {
            var currentState = $state.$current
            var breadcrumbs = setSiblingsOnBreadcrumbsArray(currentState)
            if (roleId == globalConfig.userRolesIds.reviewer && 
              ($stateParams.stage == GlobalConfig.workplanStages.reviewExecution || $stateParams.stage == GlobalConfig.workplanStages.review)) {
              filterOptions(breadcrumbs, function (data) {
                buildingBreadcrumbs(data, currentState)
              })
            } else {
              buildingBreadcrumbs(breadcrumbs, currentState)
            }
          }

          function buildingBreadcrumbs (breadcrumbs, currentState) {
            var workingState
            var displayName

            if (currentState && currentState.name !== '') {
              workingState = getWorkingState(currentState)
              if (workingState) {
                displayName = getDisplayName(workingState)
                if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs) && displayName !== "Inicio") //&& displayName !== "Inicio"
                 {
                  let active = false
                  let order = null
                  let route = null
                  if (workingState == $state.$current) {
                    active = true
                    order = (workingState.data) ? workingState.data.order : null
                  }

                  if (workingState.redirectTo) {
                    route = $state.href(workingState.redirectTo)
                  } else {
                    route = $state.href(workingState.name)
                  }

                  breadcrumbs.push({
                    displayName: displayName,
                    route: route,
                    active: active,
                    order: order
                  })
                }
              }
              currentState = currentState.parent
            }
            breadcrumbs.sort(function (a, b) {
              if (b.order == null) return 1
              return a.order - b.order
            })
            scope.breadcrumbs = breadcrumbs
          }

                /**
                 * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
                 * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
                 * set it to `false` which means this breadcrumb level will be skipped entirely.
                 * @param currentState
                 * @returns {*}
                 */
          function getWorkingState (currentState) {
            var proxyStateName
            var workingState = currentState
            if (currentState.abstract === true) {
              if (typeof scope.abstractProxyProperty !== 'undefined') {
                proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState)
                if (proxyStateName) {
                  workingState = $state.get(proxyStateName)
                } else {
                  workingState = false
                }
              } else {
                workingState = false
              }
            }
            return workingState
          }

                /**
                 * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
                 * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
                 * properties on the state config object, by using the usual {{ }} syntax.
                 * @param currentState
                 * @returns {*}
                 */
          function getDisplayName (currentState) {
            var interpolationContext
            var propertyReference
            var displayName

            if (!scope.displaynameProperty) {
                        // if the displayname-property attribute was not specified, default to the state's name
              return currentState.name
            }
            propertyReference = getObjectValue(scope.displaynameProperty, currentState)

            if (propertyReference === false) {
              return false
            } else if (typeof propertyReference === 'undefined') {
              return currentState.name
            } else {
                        // use the $interpolate service to handle any bindings in the propertyReference string.
              interpolationContext = (typeof currentState.locals !== 'undefined') ? currentState.locals.globals : currentState
              displayName = $interpolate(propertyReference)(interpolationContext)
              return displayName
            }
          }

                /**
                 * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
                 * value found at that path.
                 *
                 * @param objectPath
                 * @param context
                 * @returns {*}
                 */
          function getObjectValue (objectPath, context) {
            var i
            var propertyArray = objectPath.split('.')
            var propertyReference = context

            for (i = 0; i < propertyArray.length; i++) {
              if (angular.isDefined(propertyReference[propertyArray[i]])) {
                propertyReference = propertyReference[propertyArray[i]]
              } else {
                            // if the specified property was not found, default to the state's name
                return undefined
              }
            }
            return propertyReference
          }

                /**
                 * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
                 * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
                 * @param state
                 * @param breadcrumbs
                 * @returns {boolean}
                 */
          function stateAlreadyInBreadcrumbs (state, breadcrumbs) {
            var i
            var alreadyUsed = false
            for (i = 0; i < breadcrumbs.length; i++) {
              if (breadcrumbs[i].route === state.name) {
                alreadyUsed = true
              }
            }
            return alreadyUsed
          }

          function setSiblingsOnBreadcrumbsArray (currentState) {
            let displayName
            let breadcrumbs = []
            let workingState = getWorkingState(currentState)
            //console.log("workingState", workingState)
            if (workingState && workingState.data && workingState.data.siblings) {
              for (var i = workingState.data.siblings.length - 1; i >= 0; i--) {
                let workingStateSibling = $state.get(workingState.data.siblings[i].name)
                //console.log("workingStateSibling------>",workingStateSibling)
                if (workingStateSibling) {
                  displayName = getDisplayName(workingStateSibling)
                  let order = workingState.data.siblings[i].order
                  let rolesAllowed = workingState.data.siblings[i].rolesAllowed || []
                  let hideLink = workingState.data.siblings[i].hideLink
                  let params = workingState.data.siblings[i].params
                  let paramsRoute = {}
                  if (params) {
                    for (let param in params) {
                      paramsRoute[ param ] = $stateParams[ params[ param ] ]
                    }
                  }
                  //console.log("workingState.data", workingState.data)
                  let route = $state.href(workingStateSibling.name, paramsRoute)

                  if (displayName !== false) {
                   if ((rolesAllowed.length > 0 && rolesAllowed.findIndex(el => {return el==roleId}) >= 0) || (rolesAllowed.length == 0)) {
                     breadcrumbs.push({
                       displayName: displayName,
                       route: route,
                       order: order,
                       hideLink: hideLink
                     })
                   }
                 }
                }
              }
            }
            return breadcrumbs
          }
        }
      }
    };
})()



// WEBPACK FOOTER //
// ./src/services/ngbreadcrumb.js